import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { KundenFilter } from '../entities/customers/kundenfilter.entity';
import { KundenFilterErgebnis } from '../entities/customers/kundenfilterergebnis.entity';
//#endregion

@Injectable()
export class CustomerFilterResultService extends ODataEntityService<KundenFilterErgebnis> {
  constructor(protected client: ODataClient) {
    super(client, 'CustomerFilterResult', 'entities.customers.KundenFilterErgebnis');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public kundenFilter(entity: EntityKey<KundenFilterErgebnis>): ODataNavigationPropertyResource<KundenFilter> {
    return this.entity(entity).navigationProperty<KundenFilter>('kundenFilter');
  }
  //#endregion
}
